import {useLazyRemoveAddonQuery} from "@CheckOrder/api/checkOrderApi";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import VehicleAddonType from "@CheckOrder/types/VehicleAddon.type";

export default function useHandleJadrolinijaVehicleRemoval(vehicle: VehicleAddonType) {
    const [removeAddonQuery] = useLazyRemoveAddonQuery()
    const {
        ticket: {
            ticketCode,
        },
        passengers,
    } = useAppSelector((state) => state.checkOrder)

    const removeVehicle = () => {
        removeAddonQuery({
            passengerId: vehicle.passengerId,
            ticketCode,
            passengers,
        })
    }

    return {
        removeVehicle,
    }
}